
// ExibirAreceber.js

import React, { useState, useEffect } from 'react';
import DatepickerField from './DatepickerField';  // Importar o campo de data
import CurrencyField from './CurrencyField';      // Importar o campo de moeda
import ModalDetalhesCliente from './ModalDetalhesCliente'; // Certifique-se de que o caminho está correto
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';
import './ModalDetalhesCliente.css';
import './ModalContasAreceber.css';

const ExibirAreceber = ({ areceber, handleSaveAreceber, handleCancelaExibe }) => {

  const [detalhesCliente, setDetalhesCliente] = useState(false);

  
  const [formData, setFormData] = useState({
    nomecli: '',  // Valor inicial vazio
    cnpjcli: '',  // Valor inicial vazio
    codcli: '',  // Valor inicial vazio
    idcliente: '',  // Estado para armazenar dados do cliente selecionado
    dtpagamento: areceber.dtpagamento || '',  // Valor inicial vazio
    valpagamento: areceber.valpagamento || 0, // Valor do pagamento
    desconto: areceber.desconto || 0,         // Desconto aplicado
    valmulta: areceber.valmulta || 0,         // Multa aplicada
    valjuros: areceber.valjuros || 0,         // Juros aplicados
  });

// Atualiza o estado do formulário com os valores de "areceber"
useEffect(() => {
  if (areceber) {
    // Atualiza o estado do formulário com os valores de "areceber" (editáveis)
    setFormData({
      clienteid: areceber.cliente ? areceber.cliente.id : '',
      nomefor: areceber.cliente ? areceber.cliente.nomefor : '',
      codfor: areceber.cliente ? areceber.cliente.codfor : '',
      cnpjfor: areceber.cliente ? areceber.cliente.cnpjfor : '',
      dtpagamento: areceber.dtpagamento || '',   // Não preenche com a data atual
      valpagamento: areceber.valpagamento || 0,  // Valor do pagamento
      desconto: areceber.desconto || 0,          // Desconto aplicado
      valmulta: areceber.valmulta || 0,          // Multa aplicada
      valjuros: areceber.valjuros || 0,          // Juros aplicados
    });
  }
}, [areceber]); // Executa o efeito sempre que "areceber" mudar

  
  // Função para abrir ou fechar os detalhes do fornecedor
  const toggleDetalhesCliente = () => {
    setDetalhesCliente(!detalhesCliente);
  };


  // Função para manipular a mudança nos campos
  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // Função para formatar o valor de moeda brasileira
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  // Função para formatar a data no formato "DD/MM/YYYY"
  const formatarData = (data) => {
    if (!data) return "Data não disponível";
    const partes = data.split('-');
    if (partes.length !== 3) return "Data inválida";
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
  };


// Função para calcular o valor do Pagamento após aplicar desconto, multa e juros
const calcularTotal = () => {
  const { desconto, valmulta, valjuros, dtpagamento } = formData;
  const valparcela = areceber.valparcela; // Acesse o valor da parcela

  // Verifica se a data de pagamento foi preenchida
  if (!dtpagamento) {
  return 0; // Retorna 0 ou outro valor padrão se a data não for fornecida
  //alert("Por favor, preencha a data de pagamento antes de calcular o total.");
  }
  // Calcule o valor do pagamento apenas se a data de pagamento existir
  return valparcela - desconto + valmulta + valjuros;
  };
  
  
  const handleSubmit = async () => {
    try {
      await api.put(`/areceber/atualizarareceber/${areceber.id}`, formData, {
        headers: { 'Content-Type': 'application/json'},
      });
      alert('Registro atualizado com sucesso!');
      handleSaveAreceber(formData); // Atualiza a exibição dos dados
    } catch (error) {
      console.error('Erro ao atualizar registro:', error);
      alert('Erro ao atualizar registro.');
    }
  };


  return (
    <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto', paddingTop: '10px' }}>
      <h3 translate="no">{'Contas a Receber'}</h3>

      {areceber ? (
        <div style={{ textAlign: 'left', margin: '0 20px' }}>

          <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ marginRight: '0px', width: '420px' }}>
            <label style={{ display: 'block', width: '420px', marginRight: '0px' }}>Cliente</label>
            <input type="text" value={areceber.nomecli} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
                      
          <div style={{ width: '150px' }}>
            <label style={{ display: 'block', width: '150px', marginBottom: '0px', marginLeft: '20px' }}>CNPJ Cliente</label>
            <input type="text" value={areceber.cnpjcli} readOnly style={{ width: '160px', height: '30px', marginLeft: '20px' }} />
            </div>
            
          
            <div style={{ width: '120px' }}>
              <button className="btn-truncate" title="Detalhes do Cliente"
                onClick={toggleDetalhesCliente} style={{ width: '120px', marginTop: '24px', marginLeft: '50px', height: '30px' }}>Cliente</button>
            </div>

          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '10px' }}>
            <div style={{ width: '60px' }}>
              <label>Venda</label>
              <input type="text" value={areceber.codvenda} readOnly style={{ width: '60px', height: '30px' }} />
            </div>

            <div style={{ width: '100px', marginLeft: '20px' }}>
              <label>Nota Fiscal</label>
              <input type="text" value={areceber.nfvenda} readOnly style={{ width: '100px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label>Valor Venda</label>
              <input type="text" value={formatarMoeda(areceber.valvenda)} readOnly style={{ width: '120px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label translate="no">Dt Venda</label>
              <input type="text" value={formatarData(areceber.dtvenda)} readOnly style={{ width: '120px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label translate="no">Dt Vencimento</label>
              <input type="text" value={formatarData(areceber.dtvencimento)} readOnly style={{ width: '120px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label translate="no">Dt Pagamento</label>
              <DatepickerField
                value={formData.dtpagamento}
                onChange={(value) => handleChange('dtpagamento', value)}
              />
            </div>
          </div>

          
          <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '30px' }}>
            
            <div style={{ width: '60px', marginRight: '20px' }}>
              <label>Parcela</label>
              <input type="text" value={areceber.parcela} readOnly style={{ width: '60px', height: '30px' }} />
            </div>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label>Valor Parcela</label>
              <input type="text" value={formatarMoeda(areceber.valparcela)} readOnly style={{ width: '100px', height: '30px' }} />
            </div>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label>Desconto</label>
              <CurrencyField
                value={formData.desconto}
                onChange={(value) => handleChange('desconto', value)}
              />
            </div>

            <div style={{ width: '100px', marginLeft: '20px', marginRight: '20px' }}>
              <label translate="no">Multa</label>
              <CurrencyField
                value={formData.valmulta}
                onChange={(value) => handleChange('valmulta', value)}
              />
            </div>

            <div style={{ width: '100px', marginLeft: '20px', marginRight: '20px' }}>
              <label>Juros</label>
              <CurrencyField
                value={formData.valjuros}
                onChange={(value) => handleChange('valjuros', value)}
              />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label>Valor Pago</label>
              <input
                type="text"
                value={formatarMoeda(calcularTotal())}
                readOnly
                style={{ width: '120px', height: '30px' }}
              />
            </div>
          </div>
        
        {detalhesCliente && areceber?.cliente && (
        <ModalDetalhesCliente cliente={areceber.cliente} fecharDetalhes={toggleDetalhesCliente} />
        )}

          <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
            <button
              onClick={handleSubmit}
              style={{
                marginRight: '20px',
                width: '100px',
                height: '40px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Salvar
            </button>

            <button
              type="button"
              onClick={handleCancelaExibe}
              style={{
                width: '100px',
                height: '40px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Fechar
            </button>
          </Box>
        </div>
      ) : (
        <p>Nenhuma conta a receber disponível.</p>
      )}
    </div>
  );
};

export default ExibirAreceber;